<div class="my-packages-modal-wrapper">
    <div class="my-packages-modal">
        <div class="my-packages-header">
            {{ "My_Packages" | translate }}
            <span class="close-icon" (click)="closeModal()"><img src="./assets/icons/close_black.svg" alt="" /></span>
        </div>
        <div class="my-packages-content">
            <div class="tab-container">
                <div class="tab-option">
                    <div *ngFor="let tab of packageTabs" class="tab-item"
                        [ngClass]="{ active: tab.code === selectedPackageTab }" (click)="selectPackageTab(tab)">
                        {{ tab.label | translate }}
                    </div>
                </div>
            </div>
            <div class="appointments-view-content" *ngIf="selectedPackageTab === 'package'">
                <div class="appointments-view-toolbar">
                    <div class="appt-list-container">
                        <div class="appt-list-view">
                            <div class="list-title" *ngIf="couponList?.length">
                                {{ "Package_Subscription" | translate }}
                            </div>
                            <div class="appt-list-card" *ngFor="let item of couponList">
                                <div class="appt-card-header package-header">
                                    <img class="type-image" src="assets/icons/packages/hp_purple.svg" alt="" />
                                    {{ "Package_coupons_available" | translate }}
                                </div>

                                <div class="appointment-content">
                                    <div class="person-avatar-wrapper">
                                        <img class="type-image" [src]="getIcon(item)" alt="" />
                                    </div>

                                    <div class="appt-context">
                                        <div class="appt-title">
                                            {{item?.packageData?.concept?.name | translate: "LANGARRAY" : "name"}}
                                        </div>
                                    </div>

                                    <div class="item-detail">
                                        <div class="timeline-button">
                                            <button class="button-primary" (click)="openBookSubsequentAppt(item); $event.stopPropagation()">
                                                {{ "Review_&_Book_package" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-title" *ngIf="awaitingList?.length">
                                {{ "Service" | translate }}
                            </div>
                            <div class="appt-list-card" *ngFor="let item of awaitingList">
                                <div class="appt-card-header package-header">
                                    <img class="type-image" src="assets/icons/packages/hp_purple.svg" alt="" />
                                    {{ "Health_Package_Clinic" | translate }}
                                </div>

                                <div class="appointment-content">
                                    <div class="person-avatar-wrapper">
                                        <img class="type-image" [src]="getIcon(item)" alt="" />
                                    </div>

                                    <div class="appt-context">
                                        <div class="appt-title">
                                            {{item?.packageInfo?.packageObject?.name | translate: "LANGARRAY" : "name"}}
                                        </div>
                                    </div>

                                    <div class="item-detail">
                                        <div class="timeline-button" *ngIf="item['actionType'] == 'PACKSUBSERVICE'">
                                            <button class="button-primary" (click)="openBookSubsequentAppt(item); $event.stopPropagation()">
                                                {{ "Book_appointment" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="appointment-for-content">
                                    <p class="appt-for">
                                        {{ "For:" | translate }}
                                        <span class="bold">{{item["_patientObj"]["personname"]}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="appointments-view-content" *ngIf="selectedPackageTab === 'service'">
                <p>Service</p>
            </div>
            <div class="appointments-view-content" *ngIf="selectedPackageTab === 'doctor'">
                <p>Doctor Recommended Service</p>
            </div>
        </div>
        <!-- <div class="appointments-view-content">z
            <div class="appointments-view-toolbar">
                <div class="appt-list-container">
                    <div class="appt-list-view">
                        <div class="appt-list-card" *ngFor="let item of awaitingList">
                            <div class="appt-card-header package-header">
                                <img class="type-image" src="assets/icons/packages/hp_purple.svg" alt="">
                                {{'Health_Package_Clinic' | translate}}
                            </div>
                            <div class="appointment-content">
                                <div class="person-avatar-wrapper">
                                    <img class="type-image" [src]="getIcon(item)" alt="">
                                </div>
                                <div class="appt-context">
                                    <div class="appt-title">{{item?.packageInfo?.packageObject?.name | translate :
                                        'LANGARRAY':
                                        'name'}}</div>
                                </div>
                                <div class="item-detail">
                                    <div class="timeline-button" *ngIf="item['actionType'] == 'PACKSUBSERVICE'">
                                        <ng-container>
                                            <button class="button-primary"
                                                (click)="openBookSubsequentAppt(item); $event.stopPropagation();">
                                                {{'Book_appointment'|translate}}
                                            </button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="appointment-for-content">
                                <p class="appt-for"> {{'For:' | translate}}
                                    <span class="bold">{{item['_patientObj']['personname']}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>

<div class="package-unavail-overlay" *ngIf="showPackageUnavailable" (click)="closePackageUnavailModal()">
    <div class="package-unavail-modal" (click)="$event.stopPropagation()">
        <div class="package-unavail-header">
            <span class="package-unavail-title">{{'Package_unavailable' | translate}}</span>
            <span class="close-icon" (click)="closePackageUnavailModal()">
                <img src="./assets/icons/close_black.svg" alt="" />
            </span>
        </div>
        <div class="package-unavail-body">
            <div class="warning-icon">
                <img src="./assets/icons/error-info.svg" alt="" />
            </div>
            <p class="unavail-message">
                {{'Package_unavailable_message' | translate}}
            </p>
        </div>
        <!-- <div class="package-unavail-footer">
            <button class="button-primary call-us-btn" (click)="closePackageUnavailModal()">
                {{'Call_us' | translate}}
            </button>
        </div> -->
    </div>
</div>